'use client';

import { mdiFileUpload } from '@mdi/js';
import { useRef } from 'react';
import IconButton, {
    IconButtonVariant,
} from '@/components/Redactie/IconButton/IconButton';

interface UploadButtonProps {
    label: string;
    icon?: string;
    variant?: IconButtonVariant;
    onChange: (files: FileList | null) => void;
    multiple?: boolean;
    enabled?: boolean;
    accept?: string;
    className?: string;
    children?: React.ReactNode;
}

const UploadButton = ({
    label,
    icon,
    variant = IconButtonVariant.Primary,
    onChange,
    multiple = false,
    enabled = true,
    accept = 'image/jpeg, video/mp4',
    className,
    children,
}: UploadButtonProps) => {
    const inputRef = useRef<HTMLInputElement | null>(null);

    return (
        <>
            <input
                tabIndex={-1}
                className="hidden"
                multiple={multiple}
                ref={inputRef}
                type="file"
                onChange={(event) => {
                    if (event.target.files && event.target.files.length > 5) {
                        alert('Selecteer maximaal 5 bestanden');
                        return;
                    }
                    onChange(event.target.files);
                }}
                accept={accept}
            />
            <IconButton
                label={label}
                enabled={enabled}
                className={className}
                variant={variant}
                icon={icon ?? mdiFileUpload}
                onClick={() => {
                    inputRef.current?.click?.();
                }}
            >
                {children}
            </IconButton>
        </>
    );
};

export default UploadButton;
